import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

// For development, we'll remove StrictMode to avoid the warnings
// In production, these warnings won't appear anyway
const isDevelopment = process.env.NODE_ENV === 'development';

if (isDevelopment) {
  root.render(
    <HelmetProvider>
      <Router>
        <App />
      </Router>
    </HelmetProvider>
  );
} else {
  root.render(
    <HelmetProvider>
      <React.StrictMode>
        <Router>
          <App />
        </Router>
      </React.StrictMode>
    </HelmetProvider>
  );
}